exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.submit-info[data-v-4b0cb5c1] {\n  color:black;\n  font-size: 12px;\n  padding: 5px 15px;\n}\n.calendar-link[data-v-4b0cb5c1] {\n  color: #0b57d0;\n  cursor: pointer;\n  text-decoration: none;\n}\n.calendar-link[data-v-4b0cb5c1]:hover {\n  color: blue;\n  text-decoration: underline;\n}\n", ""]);

// exports
